<template>
	<div>
		<!--患者列表-->
		<HomePatientList ref="homePatientList" @clickSelect="getPatient" />

		<div v-if="type === 'homeStyle'" class="home_patient_base_homeStyle">
			<div class="base_detail">
				<div class="name">你好，{{ patientName }}</div>
				<!-- -->
				<div @click="clickPerfectInfo" class="label" v-if="!status">请完善信息 <van-icon name="arrow" /></div>
			</div>
			<div class="button" v-if="showArchive&&list.length>1">
				<van-badge :dot="archiveDot">
					<span @click="toggleArchive">切换档案</span>
				</van-badge>
			</div>
		</div>
		<div v-else-if="type === 'pageStyle'" class="home_patient_base_pageStyle">
			<img :src="avatar" />
			<div class="content">
				<p class="name">{{ patientName }}</p>
				<p>{{ gender }} {{ age }}</p>
			</div>
			<div class="button" v-if="showArchive&&list.length>1" @click="toggleArchive">
				切换档案 <van-icon name="arrow" />
			</div>
		</div>
		<div v-else class="home_patient_base" :class="[`home_patient_base__${type}`]">
			<p class="text-right toggle_archives" v-if="showToggleArchive&&toggleArchiveType==='header'">
				<van-badge :dot="archiveDot">
					<span @click="$emit('toggleArchive')">切换档案</span>
				</van-badge>
			</p>
			<div class="home_patient mt-28" @click="clickPerfectInfo">
				<div class="avatar">
					<img v-if="avatar" :src="avatar" :alt="patientName" :title="patientName" />
					<img v-else src="@/assets/img/default_avatar.png" alt="" />
				</div>
				<div class="main">
					<div class="info">
						<h2 class="patient">
							<slot v-if="$slots.label" name="label"></slot>
							<span v-else>{{ patientName || '--' }}</span>
						</h2>
						<div class="desc">
							<slot v-if="$slots.desc" name="desc"></slot>
							<span v-else>{{ desc || '--' }}</span>
						</div>
					</div>
					<div class="button" v-if="showRight">
						<div
							v-if="showToggleArchive&&toggleArchiveType === 'button'"
							class="mr-24 action"
							:class="actionClass"
						>
							<span class="primary" @click.stop="$emit('toggleArchive')">
								<van-badge :dot="archiveDot"> 切换患者 </van-badge>
							</span>
							<img v-if="type === 'gray'" src="@/assets/icon/icon_arrow_gray.png" alt="" />
							<img v-else src="@/assets/icon/icon_arrow_primary.png" alt="" />
						</div>
						<div class="action" :class="actionClass" v-if="toggleArchiveType === 'button'?!status:true">
							<span class="primary" v-if="!status">请完善信息</span>
							<img v-if="type === 'gray'" src="@/assets/icon/icon_arrow_gray.png" alt="" />
							<img v-else src="@/assets/icon/icon_arrow_primary.png" alt="" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HomePatientList from './home-patient-list.vue'
export default {
    name: "HomePatientBase",
    components: { HomePatientList },
    data () {
        return {
            list: []
        }
    },
    props: {
        // type
        type: {
            type: String,
            default: ''
        },
        showArchive: {
            type: Boolean,
            default: true
        },
        // 是否显示切换档案dialog
        showChangeArchiveDialog: {
            type: Boolean,
            default: true
        },
        // 是否展示切换档案成功提示
        showSuccessToast: {
            type: Boolean,
            default: true
        },
        patientDetail: {
            type: Object,
            default: () => { }
        },


        /**
         * 健康档案按钮类型
         * header:'顶部'
         * button:'按钮区域'
         */
        toggleArchiveType: {
            type: String,
            default: 'header'
        },


        // // 患者头像
        // avatar: {
        //     type: String,
        //     default: ''
        // },

        // 描述信息
        desc: {
            type: String,
            default: ''
        },

        actionClass: {
            type: String,
            default: ''
        },
        showRight: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        info () {
            return this.patientDetail || this.$store.getters['account/patientInfo'] || {}
        },
        patientName () {
            return this.info.name || '--'
        },
        //当前患者是否完善信息
        status () {
            return this.info.approveStatus
        },
        patientId () {
            return this.$store.getters['account/getPatientId']
        },
        // 是否显示切换档案小红点
        archiveDot () {
            return this.info.otherPatientStatus
        },
        avatar () {
            return this.info.avatar
        },
        gender () {
            return this.$status.gender[this.info.gender]
        },
        age () {
            return `${this.info.age || '0'}岁`
        }
    },
    created () {
        if (!this.info.id) {
            this.getPatient()
        }
        if (this.showArchive) {
            this.getPatientList()
        }
    },
    methods: {
        async getPatientList () {
            const res = await this.$api.patient.getPatientList()
            if (!res.code) {
                this.list = res.data
            }
        },
        clickPerfectInfo () {
            if (this.info.id) {
                this.$router.push(`/health/base/${this.info.id}`)
            }
        },
        /**
         * @method 获取患者信息
         * @param { string } params.id 患者id
         * @param { string } params.type 切换档案标识
         */
        getPatient (params) {
            const _this = this
            this.$store.dispatch('account/actionSwitchPatient', {
                params: (params && params.id) || this.patientId,
                callback: () => {
                    if (params && params.type === 'toggle' && this.showSuccessToast) _this.$toast.success('档案切换成功')
                    _this.$emit('onChange')
                },
                dialog: this.showChangeArchiveDialog
            })
        },
        toggleArchive () {
            this.$refs.homePatientList.init(this.info.id)
        }
    }
};
</script>

<style scoped lang="less">
.home_patient_base_pageStyle {
	display: flex;
	align-items: center;
	img {
		width: 88px;
		height: 88px;
		border-radius: 44px;
		margin-right: 20px;
		object-fit: cover;
	}
	.content {
		color: @gray-9;
		font-size: 26px;
		flex: 1;
		.name {
			font-size: 34px;
			color: #1f2329;
			line-height: 48px;
			margin-bottom: 4px;
		}
	}
	.button {
		color: @primary;
		font-size: 28px;
	}
}
.home_patient_base_homeStyle {
	display: flex;
	align-items: center;
	.base_detail {
		flex: 1;
		color: #ffffff;
		.name {
			font-size: 40px;
		}
		.label {
			font-size: 26px;
			margin-top: 11px;
			font-weight: 300;
			opacity: 0.8;
		}
	}
	.button {
		color: #ffffff;
		font-size: 26px;
		padding: 12px 0;
		width: 160px;
		text-align: center;
		border-radius: 40px;
		border: 1px solid #ffffff;
	}
}
.home_patient_base {
	.toggle_archives {
		margin: 10px 0 0;
		height: 36px;
		font-family: PingFangSC-Regular;
		font-size: 26px;
		line-height: 36px;
		color: @gray-9;
	}
	.home_patient {
		display: flex;
		justify-content: space-between;
		.avatar {
			flex: 0 0 88px;
			> img {
				width: 88px;
				height: 88px;
				vertical-align: middle;
			}
		}
		.main {
			flex: auto;
			padding-left: 20px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.info {
				max-width: 70%;
				.patient {
					min-height: 48px;
					font-family: PingFangSC-Medium;
					font-size: 34px;
					font-weight: 500;
					color: #1f2329;
				}
				.desc {
					margin-top: 8px;
					font-family: PingFangSC-Regular;
					font-size: 24px;
					font-weight: normal;
					color: @gray-9;
				}
			}
			.button {
				display: flex;
				justify-content: flex-end;
				align-items: center;
			}
			.action {
				height: 36px;
				font-family: PingFangSC-Regular;
				font-size: 26px;
				line-height: 36px;
				font-weight: normal;
				> img {
					width: 28px;
					height: 28px;
					vertical-align: middle;
				}
			}
		}
	}
	&.home_patient_base__gray {
		.action {
			> span {
				color: @gray-9;
			}
		}
	}
}
</style>
